<ng-container *uiModalDescription>
  <div class="subtitle">
    <i class="kpi-icon" ui-icon uiTheme="fill" uiType="kpi"></i>
    <div class="kpi-name">{{ kpi.name }}</div>
  </div>
</ng-container>
<form-group>
  <numeric-form-item
    [labelText]="'value' | localize"
    [value]="lastSnapshot?.value"
    [inputPrefix]="kpi.formatting.prefix"
    [inputSuffix]="kpi.formatting.suffix"
    [required]="true"
    [placeholder]="'enter_value' | localize"
    [errorMessages]="{
      required: 'the_value_is_required' | localize
    }"
    [useThousandsFormatter]="true"
    controlName="value"></numeric-form-item>
  <date-picker-form-item
    [value]="lastSnapshot?.key"
    [validators]="dateValidators"
    [required]="true"
    [isDateDisabled]="isDateDisabled"
    [backdrop]="true"
    [labelText]="'check_in_date' | localize"
    controlName="date"></date-picker-form-item>
</form-group>
